
const ar = {
  // General
  app_name: 'بوابة الدعم الفني',
  app_title: 'نظام إدارة التذاكر',
  loading: 'جاري التحميل...',
  save: 'حفظ',
  cancel: 'إلغاء',
  delete: 'حذف',
  edit: 'تعديل',
  close: 'إغلاق',
  back: 'رجوع',
  next: 'التالي',
  refresh: 'تحديث',
  search: 'بحث',
  filter: 'تصفية',
  export: 'تصدير',
  import: 'استيراد',
  actions: 'إجراءات',
  status: 'الحالة',
  no_data: 'لا توجد بيانات',
  error: 'خطأ',
  success: 'تم بنجاح',
  warning: 'تحذير',
  info: 'معلومة',
  confirm: 'تأكيد',
  yes: 'نعم',
  no: 'لا',

  // Auth
  login: 'تسجيل الدخول',
  logout: 'تسجيل الخروج',
  username: 'اسم المستخدم',
  password: 'كلمة المرور',
  odoo_url: 'رابط Odoo',
  odoo_db: 'قاعدة البيانات',
  login_button: 'دخول',
  login_error: 'فشل تسجيل الدخول. تحقق من البيانات',
  login_success: 'تم تسجيل الدخول بنجاح',
  session_expired: 'انتهت الجلسة. سجل دخولك مجدداً',

  // Navigation
  nav_dashboard: 'لوحة التحكم',
  nav_tickets: 'التذاكر',
  nav_contacts: 'العملاء',
  nav_inventory: 'المخزون',
  nav_approvals: 'الموافقات',
  nav_performance: 'الأداء',
  nav_invoices: 'الفواتير',
  nav_stock_notifications: 'إشعارات المخزون',
  nav_product_tracking: 'تتبع المنتجات',
  nav_import: 'استيراد التذاكر',
  nav_accounting: 'الحسابات',
  nav_settings: 'الإعدادات',
  nav_pos: 'نقطة البيع',
  nav_sales: 'المبيعات',
  nav_purchases: 'المشتريات',
  nav_crm: 'علاقات العملاء',
  nav_employees: 'الموظفين',
  nav_attendance: 'الحضور والانصراف',
  nav_payroll: 'المرتبات',
  nav_manufacturing: 'التصنيع',
  nav_field_service: 'العمل الميداني',
  nav_training: 'التنمية البشرية',
  nav_products: 'المنتجات',
  nav_warehouse: 'المخازن',
  nav_spare_parts: 'قطع الغيار',

  // Dashboard
  dashboard_title: 'لوحة التحكم',
  total_tickets: 'إجمالي التذاكر',
  new_tickets: 'تذاكر جديدة',
  in_progress: 'قيد التنفيذ',
  completed: 'مكتملة',
  cancelled: 'ملغاة',

  // Tickets
  tickets_title: 'إدارة التذاكر',
  ticket_number: 'رقم التذكرة',
  ticket_subject: 'عنوان التذكرة',
  ticket_customer: 'العميل',
  ticket_stage: 'المرحلة',
  ticket_priority: 'الأولوية',
  ticket_assigned: 'المسؤول',
  ticket_date: 'التاريخ',
  ticket_external_ref: 'رقم البلاغ',
  ticket_address: 'العنوان',
  ticket_phone: 'الهاتف',
  ticket_problem: 'المشكلة',
  ticket_product: 'المنتج',
  ticket_model: 'الموديل',
  ticket_sap: 'رقم الساب',
  ticket_central: 'السنترال',
  ticket_create: 'إنشاء تذكرة',
  ticket_detail: 'تفاصيل التذكرة',
  ticket_messages: 'الرسائل',
  ticket_attachments: 'المرفقات',
  priority_low: 'منخفضة',
  priority_normal: 'عادية',
  priority_high: 'عالية',
  priority_urgent: 'عاجلة',

  // Import
  import_title: 'استيراد التذاكر',
  import_subtitle: 'استيراد بلاغات الصيانة من ملفات Excel أو CSV',
  import_dropzone: 'اسحب الملف هنا أو اضغط للاختيار',
  import_dropzone_hint: 'يدعم ملفات Excel (.xlsx, .xls) و CSV',
  import_dropzone_active: 'أفلت الملف هنا',
  import_file_selected: 'تم اختيار الملف',
  import_file_size: 'حجم الملف',
  import_file_rows: 'عدد الصفوف',
  import_step_upload: 'رفع الملف',
  import_step_mapping: 'تعيين الأعمدة',
  import_step_preview: 'معاينة البيانات',
  import_step_import: 'استيراد',
  import_step_results: 'النتائج',
  import_mapping_title: 'تعيين أعمدة الملف مع حقول النظام',
  import_mapping_hint: 'ربط كل عمود في الملف بالحقل المناسب في النظام',
  import_mapping_auto: 'تعيين تلقائي',
  import_mapping_file_column: 'عمود الملف',
  import_mapping_odoo_field: 'حقل النظام',
  import_mapping_required: 'مطلوب',
  import_mapping_unmapped: 'غير معين',
  import_preview_title: 'معاينة البيانات قبل الاستيراد',
  import_preview_hint: 'راجع البيانات قبل بدء الاستيراد',
  import_preview_duplicates: 'تذاكر مكررة',
  import_preview_valid: 'صالحة للاستيراد',
  import_preview_errors: 'أخطاء',
  import_start: 'بدء الاستيراد',
  import_starting: 'جاري الاستيراد...',
  import_progress: 'تقدم الاستيراد',
  import_results_title: 'نتائج الاستيراد',
  import_results_success: 'تم الاستيراد بنجاح',
  import_results_failed: 'فشل الاستيراد',
  import_results_duplicates: 'تذاكر مكررة',
  import_results_skipped: 'تم تخطيها',
  import_results_total: 'إجمالي',
  import_results_download_report: 'تحميل التقرير',
  import_new: 'استيراد جديد',
  import_history: 'سجل الاستيراد',
  import_history_empty: 'لا يوجد سجل استيراد',
  import_manual_title: 'إضافة تذكرة يدوياً',
  import_manual_hint: 'أدخل بيانات البلاغ يدوياً',
  import_manual_ref: 'رقم البلاغ *',
  import_manual_name: 'اسم العميل',
  import_manual_phone: 'رقم الهاتف',
  import_manual_address: 'العنوان',
  import_manual_problem: 'المشكلة',
  import_manual_product: 'المنتج',
  import_manual_model: 'الموديل',
  import_manual_sap: 'رقم الساب',
  import_manual_central: 'السنترال',
  import_manual_submit: 'تسجيل البلاغ',
  import_error_file_type: 'نوع الملف غير مدعوم',
  import_error_file_size: 'حجم الملف يتجاوز الحد المسموح',
  import_error_parse: 'فشل تحليل الملف',
  import_error_no_ref: 'رقم البلاغ مطلوب',
  import_error_exists: 'تذكرة موجودة مسبقاً',
  import_error_create: 'فشل إنشاء التذكرة',

  // Auth - Enhanced
  email: 'البريد الإلكتروني',
  phone: 'رقم الهاتف',
  login_email: 'البريد الإلكتروني',
  login_phone: 'رقم الهاتف',
  login_method_email: 'دخول بالبريد الإلكتروني',
  login_method_phone: 'دخول برقم الهاتف',
  show_password: 'إظهار كلمة المرور',
  hide_password: 'إخفاء كلمة المرور',
  remember_me: 'تذكرني',
  advanced_settings: 'إعدادات متقدمة',
  connection_settings: 'إعدادات الاتصال',
  login_subtitle: 'سجل دخولك للمتابعة',
  login_identifier_placeholder_email: 'admin@example.com',
  login_identifier_placeholder_phone: '01XXXXXXXXX',

  // Settings
  settings_title: 'الإعدادات',
  settings_language: 'اللغة',
  settings_theme: 'المظهر',
  settings_theme_light: 'فاتح',
  settings_theme_dark: 'داكن',
  settings_theme_system: 'تلقائي',
  settings_odoo: 'إعدادات الاتصال',
  settings_about: 'حول التطبيق',
  settings_config_keys: 'مفاتيح الإعدادات',
  settings_config_desc: 'إدارة إعدادات التطبيق بدون تعديل الكود',
  settings_config_key: 'المفتاح',
  settings_config_value: 'القيمة',
  settings_config_default: 'الافتراضي',
  settings_config_overridden: 'معدّل',
  settings_config_reset: 'إعادة تعيين',
  settings_config_reset_all: 'إعادة تعيين الكل',
  settings_config_reset_confirm: 'هل تريد إعادة تعيين جميع الإعدادات للقيم الافتراضية؟',
  settings_config_save: 'حفظ الإعدادات',
  settings_config_saved: 'تم حفظ الإعدادات',
  settings_config_reset_done: 'تم إعادة التعيين',
  settings_connection_info: 'معلومات الاتصال',
  settings_odoo_url: 'رابط Odoo',
  settings_odoo_db: 'قاعدة البيانات',
  settings_backend_url: 'رابط الخادم الخلفي',
  settings_user_info: 'معلومات المستخدم',
  settings_session: 'الجلسة',

  // Notifications
  notifications: 'الإشعارات',
  notifications_empty: 'لا توجد إشعارات',
  notifications_clear_all: 'مسح الكل',
  notifications_mark_read: 'تحديد كمقروء',
  notification_login_success: 'تم تسجيل الدخول بنجاح',
  notification_logout: 'تم تسجيل الخروج',
  notification_session_expired: 'انتهت الجلسة. سجل دخولك مجدداً',
  notification_phone_not_found: 'لم يتم العثور على حساب مرتبط بهذا الرقم',
  notification_rate_limited: 'تم تجاوز الحد المسموح من المحاولات',
  notification_ticket_created: 'تم إنشاء التذكرة بنجاح',
  notification_ticket_updated: 'تم تحديث التذكرة',
  notification_import_complete: 'تم الاستيراد بنجاح',
  notification_import_failed: 'فشل الاستيراد',
  notification_config_loaded: 'تم تحميل الإعدادات من السيرفر',
  notification_config_error: 'فشل تحميل الإعدادات',

  // Security
  security_rate_limit: 'تم تجاوز الحد المسموح من المحاولات',
  security_session_timeout: 'انتهت الجلسة',
  security_unauthorized: 'غير مصرح',
  settings_server_config: 'إعدادات السيرفر (Cloudflare)',
  settings_server_config_desc: 'يتم التحكم بهذه الإعدادات من لوحة Cloudflare',
  settings_source: 'المصدر',

  // ─── Sales Module ───
  sales_title: 'إدارة المبيعات',
  sales_quotation: 'عرض سعر',
  sales_order: 'أمر بيع',
  sales_new: 'إنشاء عرض سعر',
  sales_customer: 'العميل',
  sales_date: 'التاريخ',
  sales_amount: 'المبلغ',
  sales_state: 'الحالة',
  sales_salesperson: 'مسؤول المبيعات',
  sales_team: 'فريق المبيعات',
  sales_deadline: 'موعد التسليم',
  sales_payment_term: 'شروط الدفع',
  sales_draft: 'مسودة',
  sales_sent: 'مرسلة',
  sales_confirmed: 'مؤكدة',
  sales_done: 'مكتملة',
  sales_cancel: 'ملغاة',
  sales_lines: 'بنود الأمر',
  sales_product: 'المنتج',
  sales_quantity: 'الكمية',
  sales_unit_price: 'سعر الوحدة',
  sales_discount: 'الخصم',
  sales_subtotal: 'المجموع الفرعي',
  sales_tax: 'الضريبة',
  sales_total: 'الإجمالي',
  sales_confirm_order: 'تأكيد الأمر',
  sales_send_quotation: 'إرسال عرض السعر',

  // ─── Purchases Module ───
  purchases_title: 'إدارة المشتريات',
  purchases_order: 'أمر شراء',
  purchases_new: 'إنشاء أمر شراء',
  purchases_vendor: 'المورد',
  purchases_date: 'التاريخ',
  purchases_amount: 'المبلغ',
  purchases_state: 'الحالة',
  purchases_buyer: 'مسؤول المشتريات',
  purchases_planned_date: 'التاريخ المخطط',
  purchases_origin: 'المصدر',
  purchases_to_approve: 'بانتظار الموافقة',
  purchases_confirm: 'تأكيد الأمر',

  // ─── CRM Module ───
  crm_title: 'إدارة علاقات العملاء',
  crm_lead: 'فرصة / عميل محتمل',
  crm_opportunity: 'فرصة',
  crm_new_lead: 'عميل محتمل جديد',
  crm_new_opportunity: 'فرصة جديدة',
  crm_contact_name: 'اسم جهة الاتصال',
  crm_email: 'البريد الإلكتروني',
  crm_phone: 'الهاتف',
  crm_stage: 'المرحلة',
  crm_probability: 'الاحتمالية',
  crm_expected_revenue: 'الإيراد المتوقع',
  crm_planned_revenue: 'الإيراد المخطط',
  crm_source: 'المصدر',
  crm_campaign: 'الحملة',
  crm_medium: 'الوسيط',
  crm_deadline: 'الموعد النهائي',
  crm_won: 'تم الكسب',
  crm_lost: 'تم الخسارة',
  crm_lost_reason: 'سبب الخسارة',
  crm_new: 'جديد',
  crm_qualification: 'تأهيل',
  crm_proposition: 'عرض سعر',
  crm_negotiation: 'تفاوض',
  crm_pipeline: 'خط أنابيب المبيعات',
  crm_convert: 'تحويل إلى فرصة',
  crm_won_action: 'كسب',
  crm_lost_action: 'خسارة',

  // ─── HR / Employees Module ───
  employees_title: 'إدارة الموظفين',
  employees_new: 'إضافة موظف',
  employees_name: 'الاسم',
  employees_department: 'القسم',
  employees_job: 'المسمى الوظيفي',
  employees_manager: 'المدير المباشر',
  employees_email: 'البريد الإلكتروني',
  employees_phone: 'الهاتف',
  employees_mobile: 'الموبايل',
  employees_status: 'الحالة',
  employees_active: 'نشط',
  employees_absent: 'غائب',
  employees_on_leave: 'في إجازة',
  employees_national_id: 'الرقم القومي',
  employees_hire_date: 'تاريخ التعيين',
  employees_salary: 'الراتب',
  employees_allowances: 'البدلات',
  employees_deductions: 'الخصومات',
  employees_net_salary: 'صافي الراتب',
  employees_gender: 'الجنس',
  employees_birthday: 'تاريخ الميلاد',
  employees_marital: 'الحالة الاجتماعية',
  employees_contract: 'العقد',
  employees_contracts: 'العقود',

  // ─── Attendance Module ───
  attendance_title: 'الحضور والانصراف',
  attendance_check_in: 'تسجيل حضور',
  attendance_check_out: 'تسجيل انصراف',
  attendance_employee: 'الموظف',
  attendance_check_in_time: 'وقت الحضور',
  attendance_check_out_time: 'وقت الانصراف',
  attendance_worked_hours: 'ساعات العمل',
  attendance_today: 'حضور اليوم',
  attendance_late: 'متأخر',
  attendance_early: 'مبكر',
  attendance_absent: 'غائب',
  attendance_overtime: 'وقت إضافي',

  // ─── Payroll Module ───
  payroll_title: 'إدارة المرتبات',
  payroll_payslip: 'قسيمة راتب',
  payroll_new: 'إنشاء قسيمة',
  payroll_employee: 'الموظف',
  payroll_period: 'الفترة',
  payroll_date_from: 'من',
  payroll_date_to: 'إلى',
  payroll_gross: 'إجمالي الراتب',
  payroll_net: 'صافي الراتب',
  payroll_state: 'الحالة',
  payroll_draft: 'مسودة',
  payroll_verify: 'قيد المراجعة',
  payroll_done: 'مكتملة',
  payroll_contract: 'العقد',
  payroll_structure: 'هيكل الراتب',
  payroll_run: 'تشغيل المرتبات',
  payroll_batch: 'دفعة مرتبات',

  // ─── Manufacturing Module ───
  manufacturing_title: 'إدارة التصنيع',
  manufacturing_order: 'أمر تصنيع',
  manufacturing_new: 'إنشاء أمر تصنيع',
  manufacturing_product: 'المنتج',
  manufacturing_quantity: 'الكمية',
  manufacturing_state: 'الحالة',
  manufacturing_planned_start: 'تاريخ البدء المخطط',
  manufacturing_planned_end: 'تاريخ الانتهاء المخطط',
  manufacturing_responsible: 'المسؤول',
  manufacturing_bom: 'قائمة المواد',
  manufacturing_workorders: 'أوامر العمل',
  manufacturing_origin: 'المصدر',
  manufacturing_planned: 'مخططة',
  manufacturing_progress: 'قيد التنفيذ',
  manufacturing_confirm: 'تأكيد',
  manufacturing_plan: 'تخطيط',

  // ─── Field Service Module ───
  field_service_title: 'العمل الميداني',
  field_service_order: 'أمر عمل ميداني',
  field_service_new: 'إنشاء أمر عمل',
  field_service_employee: 'الفني',
  field_service_customer: 'العميل',
  field_service_scheduled_start: 'بداية الجدولة',
  field_service_scheduled_end: 'نهاية الجدولة',
  field_service_actual_start: 'البدء الفعلي',
  field_service_actual_end: 'الانتهاء الفعلي',
  field_service_location: 'الموقع',
  field_service_resolution: 'الحل',
  field_service_parts_used: 'القطع المستخدمة',
  field_service_signature: 'التوقيع',
  field_service_priority: 'الأولوية',

  // ─── Training / Human Development ───
  training_title: 'التنمية البشرية',
  training_course: 'الدورة التدريبية',
  training_new_course: 'إضافة دورة',
  training_session: 'الجلسة التدريبية',
  training_trainer: 'المدرب',
  training_start_date: 'تاريخ البدء',
  training_end_date: 'تاريخ الانتهاء',
  training_duration: 'المدة (ساعات)',
  training_category: 'الفئة',
  training_status: 'الحالة',
  training_attendees: 'المتدربين',
  training_certificate: 'شهادة',
  training_location: 'المكان',
  training_notes: 'ملاحظات',

  // ─── Products Module ───
  products_title: 'إدارة المنتجات',
  products_new: 'إضافة منتج',
  products_name: 'اسم المنتج',
  products_code: 'الكود',
  products_barcode: 'الباركود',
  products_category: 'الفئة',
  products_price: 'سعر البيع',
  products_cost: 'التكلفة',
  products_type: 'النوع',
  products_stock: 'المخزون',
  products_virtual_stock: 'المخزون المتاح',
  products_incoming: 'الوارد',
  products_outgoing: 'الصادر',
  products_tracking: 'التتبع',
  products_sale_ok: 'قابل للبيع',
  products_purchase_ok: 'قابل للشراء',
  products_brand: 'العلامة التجارية',

  // ─── Warehouse Module ───
  warehouse_title: 'إدارة المخازن',
  warehouse_picking: 'أمر تحويل',
  warehouse_new: 'إنشاء تحويل',
  warehouse_origin: 'المصدر',
  warehouse_destination: 'الوجهة',
  warehouse_state: 'الحالة',
  warehouse_scheduled: 'التاريخ المجدول',
  warehouse_done: 'تاريخ التنفيذ',
  warehouse_type: 'نوع التحويل',
  warehouse_receipt: 'استلام',
  warehouse_delivery: 'تسليم',
  warehouse_internal: 'داخلي',
  warehouse_validate: 'تحقق',

  // ─── Spare Parts Module ───
  spare_parts_title: 'قطع الغيار',
  spare_parts_available: 'قطع متاحة',
  spare_parts_requested: 'قطع مطلوبة',
  spare_parts_ordered: 'قطع مطلوبة (م Ordering)',
  spare_parts_ready: 'قطع جاهزة',
  spare_parts_used: 'قطع مستخدمة',
  spare_parts_product: 'القطعة',
  spare_parts_quantity: 'الكمية',
  spare_parts_ticket: 'التذكرة',
  spare_parts_stock: 'المخزون',

  // ─── Common Module Labels ───
  module_sales: 'المبيعات',
  module_purchases: 'المشتريات',
  module_crm: 'علاقات العملاء',
  module_hr: 'الموارد البشرية',
  module_attendance: 'الحضور',
  module_payroll: 'المرتبات',
  module_manufacturing: 'التصنيع',
  module_field_service: 'العمل الميداني',
  module_training: 'التنمية البشرية',
  module_inventory: 'المخزون',
  module_accounting: 'الحسابات',
  module_pos: 'نقطة البيع',
  module_tickets: 'التذاكر',

  // ─── Dashboard Enhanced ───
  dashboard_sales_month: 'مبيعات الشهر',
  dashboard_purchases_month: 'مشتريات الشهر',
  dashboard_new_leads: 'عملاء محتملين جدد',
  dashboard_won_opportunities: 'فرص مكتسبة',
  dashboard_active_employees: 'موظفين نشطين',
  dashboard_attendance_today: 'حضور اليوم',
  dashboard_open_invoices: 'فواتير مفتوحة',
  dashboard_overdue_invoices: 'فواتير متأخرة',
  dashboard_manufacturing_orders: 'أوامر تصنيع',
  dashboard_pending_approvals: 'موافقات معلقة',
  dashboard_stock_value: 'قيمة المخزون',
  dashboard_low_stock: 'مخزون منخفض',

  // ─── Invoice Lines Module ───
  invoice_lines: 'بنود الفاتورة',
  invoice_line_name: 'وصف البند',
  invoice_line_product: 'المنتج',
  invoice_line_quantity: 'الكمية',
  invoice_line_unit_price: 'سعر الوحدة',
  invoice_line_discount: 'الخصم %',
  invoice_line_tax: 'الضريبة %',
  invoice_line_subtotal: 'المجموع الفرعي',
  invoice_line_total: 'الإجمالي',
  invoice_line_notes: 'ملاحظات',
  invoice_add_line: 'إضافة بند',
  invoice_remove_line: 'حذف البند',
  invoice_calculate: 'حساب تلقائي',
  invoice_no_lines: 'لا توجد بنود',
  invoice_print: 'طباعة',
  invoice_link_ticket: 'ربط بتذكرة',

  // ─── Service Contract Module ───
  service_contract_title: 'عقود الصيانة',
  service_contract_new: 'إنشاء عقد',
  service_contract_partner: 'العميل',
  service_contract_product: 'المنتج',
  service_contract_start: 'تاريخ البدء',
  service_contract_end: 'تاريخ الانتهاء',
  service_contract_status: 'الحالة',
  service_contract_type: 'نوع العقد',

  // ─── Spare Parts Module (Enhanced) ───
  spare_part_title: 'قطع الغيار',
  spare_part_new: 'إضافة قطعة',
  spare_part_product: 'المنتج',
  spare_part_quantity: 'الكمية',
  spare_part_ticket: 'التذكرة',
  spare_part_status: 'الحالة',

  // ─── Stock Movement Module ───
  stock_movement_title: 'حركات المخزون',
  stock_movement_new: 'إضافة حركة',
  stock_movement_type: 'نوع الحركة',
  stock_movement_source: 'المصدر',
  stock_movement_destination: 'الوجهة',
  stock_movement_date: 'التاريخ',

  // ─── Tech Payment Module ───
  tech_payment_title: 'مدفوعات الفنيين',
  tech_payment_new: 'إنشاء طلب دفع',
  tech_payment_technician: 'الفني',
  tech_payment_amount: 'المبلغ',
  tech_payment_type: 'نوع الدفع',
  tech_payment_status: 'الحالة',
  tech_payment_date: 'التاريخ',

  // ─── Technician Inventory Module ───
  technician_inventory_title: 'مخزون الفنيين',
  technician_inventory_product: 'المنتج',
  technician_inventory_quantity: 'الكمية',
  technician_inventory_technician: 'الفني',
  technician_inventory_location: 'الموقع',

  // ─── Field Service Module (Enhanced) ───
  field_service_title_enhanced: 'أوامر العمل الميداني',
  field_service_technician: 'الفني',
  field_service_status: 'الحالة',
  field_service_start: 'بدء العمل',
  field_service_end: 'انتهاء العمل',

  // ─── Work Order Module ───
  work_order_title: 'أوامر العمل',
  work_order_new: 'إنشاء أمر عمل',
  work_order_status: 'الحالة',
  work_order_start: 'بدء',
  work_order_end: 'انتهاء',

  // ─── Call History Module ───
  call_history_title: 'سجل المكالمات',
  call_history_phone: 'رقم الهاتف',
  call_history_type: 'نوع المكالمة',
  call_history_duration: 'المدة',
  call_history_date: 'التاريخ',

  // ─── Error Codes Module ───
  error_code_title: 'رموز الأخطاء',
  error_code_name: 'الاسم',
  error_code_code: 'الرمز',
  error_code_description: 'الوصف',

  // ─── Device Errors Module ───
  device_errors_title: 'أخطاء الأجهزة',
  device_errors_product: 'المنتج',
  device_errors_code: 'رمز الخطأ',
  device_errors_solution: 'الحل',

  // ─── Ticket Enhanced Fields ───
  ticket_asc_code: 'كود ASC',
  ticket_asc_name: 'اسم ASC',
  ticket_maintance_place: 'مكان الصيانة',
  ticket_delivery_place: 'مكان التسليم',
  ticket_delivery_to: 'التسليم إلى',
  ticket_product_status: 'حالة الجهاز',
  ticket_receipt_no: 'رقم الإيصال',
  ticket_cost: 'التكلفة',
  ticket_currency: 'العملة',
  ticket_resolution: 'الحل',
  ticket_signature: 'التوقيع',
  ticket_days_from_create: 'أيام منذ الإنشاء',
  ticket_company_accounting: 'محاسبة الشركة',
  ticket_notified: 'تم الإخطار',
  ticket_place: 'المكان',

  // ─── Workflow Module ───
  workflow_title: 'سير العمل',
  workflow_step: 'خطوة',
  workflow_status: 'الحالة',
  workflow_date: 'التاريخ',

  // ─── Cash Transactions Module ───
  cash_transaction_title: 'المعاملات النقدية',
  cash_transaction_new: 'إضافة معاملة',
  cash_transaction_amount: 'المبلغ',
  cash_transaction_type: 'النوع',
  cash_transaction_date: 'التاريخ',
  cash_transaction_partner: 'الشريك',
  cash_transaction_ticket: 'التذكرة',

  // ─── Smart Actions ───
  smart_action_create_invoice: 'إنشاء فاتورة',
  smart_action_view_invoice: 'عرض الفاتورة',
  smart_action_add_maintenance: 'إجراء صيانة',
  smart_action_request_parts: 'طلب قطع غيار',
  smart_action_schedule: 'جدولة',
  smart_action_postpone: 'تأجيل',
  smart_action_cancel: 'إلغاء',
  smart_action_reopen: 'إعادة فتح',
  smart_action_confirm: 'تأكيد',
  smart_action_start_work: 'بدء العمل',
  smart_action_end_work: 'إنهاء العمل',
  smart_action_more: 'المزيد',

  // ─── Invoice Dialog ───
  invoice_create_title: 'إنشاء فاتورة',
  invoice_create_desc: 'سيتم إنشاء فاتورة مباشرة ببيانات التذكرة الحالية',
  invoice_customer: 'العميل',
  invoice_ticket: 'التذكرة',
  invoice_product: 'المنتج',
  invoice_cost: 'التكلفة',
  invoice_create_direct: 'إنشاء الفاتورة مباشرة',
  invoice_existing: 'يوجد فاتورة مرتبطة بالفعل',
  invoice_no_customer: 'يجب تحديد العميل قبل إنشاء الفاتورة',

  // ─── Maintenance Dialog ───
  maintenance_add_title: 'إضافة إجراء صيانة',
  maintenance_add_desc: 'أضف إجراء صيانة مرتبط بحسابات المصنعيات',
  maintenance_action_type: 'نوع الإجراء',
  maintenance_action_name: 'اسم الإجراء',
  maintenance_description: 'الوصف',
  maintenance_duration: 'المدة (ساعات)',
  maintenance_cost: 'التكلفة',
  maintenance_account: 'حساب المصنعيات',
  maintenance_employee: 'الفني',
  maintenance_type_inspection: 'فحص',
  maintenance_type_repair: 'إصلاح',
  maintenance_type_replacement: 'استبدال',
  maintenance_type_maintenance: 'صيانة',
  maintenance_type_installation: 'تركيب',
  maintenance_type_other: 'أخرى',

  // ─── New Ticket Fields ───
  ticket_cancel_reason: 'سبب الإلغاء',
  ticket_invoice_lines: 'بنود الفاتورة',
  ticket_spare_part_ids: 'قطع الغيار',
  ticket_maintenance_actions: 'إجراءات الصيانة',
};

export default ar;
export type TranslationKey = keyof typeof ar;
